import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";

const ServicesCategoriesIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع تصنيفات الخدمات",
				breadcrumb: "تصنيفات الخدمات",
				button: {
					show: true,
					text: "اضافة تصنيف جديد",
					link: "/servicesCategories/create",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/serviceCategories`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const columns = [
		{
			name: "ID",
			selector: "id",
			sortable: true,
		},

		{
			name: "اسم التصنيف",
			sortable: true,
			cell: row => {
				return row?.name?.ar;
			},
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						<Link
							className="bt bt-sm bt-success"
							to={`/servicesCategories/show/${row.id}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleConfirmDelete(row.id)}
						>
							<i className="fas fa-trash" />
						</button>
					</li>
				</ul>
			),
		},
	];

	const handleDelete = categoryId => {
		axios
			.delete(
				`${process.env.REACT_APP_API_URL}/serviceCategories/${categoryId}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				onStart();
				toast.success("تم الحذف بنجاح");
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handleConfirmDelete = categoryId => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => handleDelete(categoryId),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={data}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default ServicesCategoriesIndex;
